import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getVegetable = createAsyncThunk(
  "admin/vegetable",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/vegetable", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getVegetableById = createAsyncThunk(
  "admin/vegetable/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/vegetable/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortVegetable = createAsyncThunk(
  "admin/vegetable/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/vegetable/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postVegetable = createAsyncThunk(
  "admin/vegetable/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/vegetable", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteVegetable = createAsyncThunk(
  "admin/vegetable/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/vegetable/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateVegetable = createAsyncThunk(
  "admin/vegetable/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/vegetable/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const vegetableSlice = createSlice({
  name: "Vegetable Store",
  initialState: initialState,
  reducers: {
    addVegetable(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortVegetable(state, action) {
      state.data.docs = action.payload;
    },
    deleteVegetable(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editVegetable(state, action) {
      state.data.docs = state.data.docs.map((item) =>
        item._id === action.payload._id ? action.payload : item
      ); 
      state.data.docs.shift();
    },
  },
  extraReducers: {
    [getVegetable.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getVegetable.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getVegetable.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getVegetableById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getVegetableById.fulfilled]: (state, action) => {
      state.data.docs.unshift(action.payload.data);
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getVegetableById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortVegetable.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortVegetable.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortVegetable.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postVegetable.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postVegetable.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postVegetable.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteVegetable.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteVegetable.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteVegetable.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateVegetable.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateVegetable.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateVegetable.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const vegetableActions = vegetableSlice.actions;

export default vegetableSlice.reducer;
